import { useTranslation } from 'react-i18next'
import { useDangerousHTML } from '../../utils/hooks'
import LoyaltyProgram from './LoayltyProgram'

export const IndividualTMSY = () => {
    const { t } = useTranslation()
    const prefix = 'footer:individual.TMSY'
    const { p } = useDangerousHTML()

    return <>
        <LoyaltyProgram prefix={prefix} />
        {p(t(`${prefix}.7`))}
        {p(t(`${prefix}.8`))}
        {p(t(`${prefix}.9`))}
        {p(t(`${prefix}.10`))}
        {p(t(`${prefix}.11`))}
        <p>
            <strong>{t(`${prefix}.warning.header`)} </strong>
            {t(`${prefix}.warning.text`)}
        </p>
        <p>
            <strong>{t(`${prefix}.0.header`)} </strong>
            {t(`${prefix}.0.text1`)}
        </p>
        <p>{t(`${prefix}.0.text3`)}</p>
    </>
}
